<script setup>
import { onMounted, ref } from 'vue';
import { Link, router, usePage } from '@inertiajs/vue3';
import Layout from '../Components/Layout.vue';

const props = defineProps({
    plans: Array,
    active: Object,
    discount: Number,
});

const selectedPlan = ref();

const selectPlan = function (planId) {
    selectedPlan.value = planId;

    const mainButton = Telegram.WebApp.MainButton;
    mainButton.setText('Оплатить');
    mainButton.onClick(function () {
        Telegram.WebApp.MainButton.showProgress();

        router.get(`/plan/invoice/${selectedPlan.value}`);
    });
    mainButton.show();
}

onMounted(() => {
    const error = usePage().props.flash?.error;
    if (error) {
        Telegram.WebApp.showAlert(error);
    }

    Telegram.WebApp.MainButton.hide();
    Telegram.WebApp.BackButton.show();
    Telegram.WebApp.BackButton.onClick(() => router.get('/'));
});
</script>

<template>
    <Layout>
        <div class="space-y-4">
            <div class="p-6 pb-0">
                <h1 class="text-xl font-semibold">Выбор тарифа</h1>

                <p class="mt-1 text-sm leading-relaxed">
                    Тарифы отличаются количеством запросов.<br>
                    Ответ ChatGPT – 1 запрос.<br>
                    Генерация в Nano Banana – 4 запроса.<br>
                    Работа с PDF – 1 запрос за страницу.
                </p>

                <div class="mt-2">
                    <span class="font-semibold text-md">Во всех тарифах:</span>

                    <ul class="text-sm mt-2 flex flex-col space-y-2">
                        <li class="flex space-x-2">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-0.5 h-4 w-4 shrink-0"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.0633 5.67387C18.5196 5.98499 18.6374 6.60712 18.3262 7.06343L10.8262 18.0634C10.6585 18.3095 10.3898 18.4679 10.0934 18.4957C9.79688 18.5235 9.50345 18.4178 9.29289 18.2072L4.79289 13.7072C4.40237 13.3167 4.40237 12.6835 4.79289 12.293C5.18342 11.9025 5.81658 11.9025 6.20711 12.293L9.85368 15.9396L16.6738 5.93676C16.9849 5.48045 17.607 5.36275 18.0633 5.67387Z" fill="currentColor"></path></svg>
                            <span>Работа с текстом, фото и голосовыми.</span>
                        </li>
                        <li class="flex space-x-2">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-0.5 h-4 w-4 shrink-0"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.0633 5.67387C18.5196 5.98499 18.6374 6.60712 18.3262 7.06343L10.8262 18.0634C10.6585 18.3095 10.3898 18.4679 10.0934 18.4957C9.79688 18.5235 9.50345 18.4178 9.29289 18.2072L4.79289 13.7072C4.40237 13.3167 4.40237 12.6835 4.79289 12.293C5.18342 11.9025 5.81658 11.9025 6.20711 12.293L9.85368 15.9396L16.6738 5.93676C16.9849 5.48045 17.607 5.36275 18.0633 5.67387Z" fill="currentColor"></path></svg>
                            <span>Оригинальные GPT-4o и o3-mini от OpenAI.</span>
                        </li>
                        <li class="flex space-x-2">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-0.5 h-4 w-4 shrink-0"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.0633 5.67387C18.5196 5.98499 18.6374 6.60712 18.3262 7.06343L10.8262 18.0634C10.6585 18.3095 10.3898 18.4679 10.0934 18.4957C9.79688 18.5235 9.50345 18.4178 9.29289 18.2072L4.79289 13.7072C4.40237 13.3167 4.40237 12.6835 4.79289 12.293C5.18342 11.9025 5.81658 11.9025 6.20711 12.293L9.85368 15.9396L16.6738 5.93676C16.9849 5.48045 17.607 5.36275 18.0633 5.67387Z" fill="currentColor"></path></svg>
                            <span>Nano Banana.</span>
                        </li>
                        <li class="flex space-x-2">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-0.5 h-4 w-4 shrink-0"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.0633 5.67387C18.5196 5.98499 18.6374 6.60712 18.3262 7.06343L10.8262 18.0634C10.6585 18.3095 10.3898 18.4679 10.0934 18.4957C9.79688 18.5235 9.50345 18.4178 9.29289 18.2072L4.79289 13.7072C4.40237 13.3167 4.40237 12.6835 4.79289 12.293C5.18342 11.9025 5.81658 11.9025 6.20711 12.293L9.85368 15.9396L16.6738 5.93676C16.9849 5.48045 17.607 5.36275 18.0633 5.67387Z" fill="currentColor"></path></svg>
                            <span>Поиск в Google, когда важная актуальность.</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="bg-tgThemeSecondaryBgColor p-4">
                <div v-if="plans.length === 0" class="mt-2 px-4 py-3 bg-tgThemeSectionBgColor rounded-lg">
                    Пока нет вариантов для улучшения, у вас максимальный тариф.
                </div>

                <div
                    v-for="plan in plans"
                    :key="plan.id"
                    class="mt-2 px-4 py-3 bg-tgThemeSectionBgColor rounded-lg border-2"
                    :class="{ 'border-tgThemeButtonColor': plan.id === selectedPlan, 'border-transparent': plan.id !== selectedPlan }"
                    @click="selectPlan(plan.id)"
                >
                    <div class="flex items-center justify-between">
                        <div class="font-semibold text-lg">{{ plan.name }}</div>
                        <div class="w-6 h-6 flex items-center justify-center border-2 rounded-full"
                             :class="{ 'border-blue-500': plan.id === selectedPlan, 'border-gray-300': plan.id !== selectedPlan }">
                            <div class="w-3 h-3 rounded-full"
                                 :class="{'bg-blue-500': plan.id === selectedPlan, 'bg-transparent': plan.id !== selectedPlan  }"></div>
                        </div>
                    </div>

                    <span v-if="plan.id === 2" class="bg-tgThemeButtonColor rounded-lg text-xs px-2 py-1 text-tgThemeButtonTextColor">⭐️ Популярный</span>

                    <ul class="mt-1.5 text-sm">
                        <li v-for="(feature, key) in plan.features" :key="key" class="flex space-x-2">
                            <span v-html="feature"></span>
                        </li>
                    </ul>

                    <div v-if="plan.price > 0" class="mt-1.5 font-semibold">
                        <span>{{ plan.price - discount }} ₽</span>
                        <span class="text-xs text-tgThemeHintColor">&nbsp; ⧸ месяц</span>
                    </div>
                </div>

                <div class="pt-4 text-center text-xs text-tgThemeLinkColor">
                    <Link href="/docs">Юридическая информация</Link>
                </div>
            </div>
        </div>
    </Layout>
</template>
